// -- React Libraries
import React from 'react';

// -- Libraries
import axios from 'axios';

// -- Variables
import API_URL from '../../../constants/server';

// -- Components
import CampaignItem from "../CampaignItem/index";

// -- Styles
import StyleWrapper from "./Wrapper";


export default class CampaignsHolder extends React.Component {
    constructor (props) {
        super(props);

        this.AuthHeader = this.props.authHeader || '';
        this.state = {
            campaignList: null
        };

        this._getCampaignsOfUser();
    }

    async _getCampaignsOfUser () {
        const headers = { 'Authorization': this.AuthHeader };
        const response = await axios.get(`${API_URL}/user/campaigns`, { headers });
        this.setState({campaignList: response.data});
    };

    render() {
        return (
            <StyleWrapper>
                {
                    !this.state.campaignList && (
                        <li className="loading">
                            载入中...
                        </li>
                    ) || (this.state.campaignList.map( (campaign) => {
                        return (
                            <CampaignItem
                                authHeader={this.AuthHeader}
                                campaign={campaign}
                            />
                        );
                    }))
                }
            </StyleWrapper>
        )
    };
};


// WEBPACK FOOTER //
// ./src/containers/CampaignList/CampaignsHolder/index.js